<template>
  <div class="not-found">
    <h2>404 Not found</h2>
    <p class="not-found__description bhGray1--text">
      The requested page does not exist.Please go to the home page by clicking
      the button below.
    </p>
    <router-link to="/">
      <v-btn color="accent" elevation="0" rounded>
        Homepage
      </v-btn>
    </router-link>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "NotFound",
  components: {},
  data: () => ({})
};
</script>

<style lang="scss">
.not-found {
  margin: auto;
  width: 100%;
  max-width: 328px;
  padding: 12px;
}
</style>
